export default (customer) => ({
    account: {
        email: '',
        'repeat-email': '',
        password: '',
        passwordConfirm: ''
    },
    customer: customer ? customer : {
        firstname: '',
        lastname: '',
        company: '',
        addressone: '',
        addresstwo: '',
        city: '',
        state: '',
        postcode: '',
        country: '-1',
        phone: '',
        vat: '',
        ponumber: '',
    },
    licensee: {
        firstname: '',
        lastname: '',
        company: '',
        addressone: '',
        addresstwo: '',
        city: '',
        state: '',
        postcode: '',
        country: '-1',
        phone: '',
    },
    errors: {
        primary: {
            email: true,
            'repeat-email': true,
            password: true,
            passwordConfirm: true,
            firstname: true,
            lastname: true,
            company: true,
            addressone: true,
            addresstwo: true,
            country: true,
            city: true,
            state: true,
            postcode: true,
            phone: true,
            vat: true,
            ponumber: true
        },
        licensee: {
            firstname: true,
            lastname: true,
            company: true,
            addressone: true,
            addresstwo: true,
            country: true,
            city: true,
            state: true,
            postcode: true,
            phone: true,
        },
    },
    messages: {
        account: '',
        customer: '',
        licensee: ''
    },
    showLicensee: false,
    isCheckingOut: false,
    async clickSubmit() {
        if (this.isCheckingOut) {
            return
        }
        this.isCheckingOut = true
        const payload = {
            checkout: {
                account: this.account,
                customer: this.customer,
                licensee: this.showLicensee ? this.licensee : false
            }
        }
        const response = await fetch('/app/checkout', {
            method: 'POST',
            body: JSON.stringify(payload)
        })
        const data = await response.json()
        if (data.success) {
            window.location.href = `/checkout/payment?id=${encodeURIComponent(data.id)}`
        } else {
            for (const key of Object.keys(this.errors.primary)) {
                // We're having to do this "clearing" of error codes because we haven't made the server API
                // match the data structure of the JS yet. See below.
                this.errors.primary[key] = true
            }
            switch (data.reason) {
                case 'account':
                    this.messages.account = 'Your account data is invalid';
                    this.errors.primary = data.errors
                    break;
                case 'account_exists':
                    this.messages.account = 'An account with this e-mail address already exists';
                    this.errors.primary = data.errors
                    this.errors.primary.email = false
                    break;
                case 'customer':
                    this.messages.customer = 'Please check the fields below and ensure they are valid';
                    this.errors.primary = data.errors
                    break;
                case 'licensee':
                    this.errors.licensee = data.errors
                    this.messages.licensee = 'Please check the fields below and ensure they are valid';
                    break;
            }
        }
        this.isCheckingOut = false
    }
})